import React, { useState, useCallback } from "react";
import Gallery from "react-photo-gallery";
import YakshaganaStringPuppetsSection from "../../components/forms/TwoColContactUsWithIllustration";
import Carousel, { Modal, ModalGateway } from "react-images";
import { photos } from "./photos/puppet_performance_photos.js";

function PerformancePhotos() {
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const openLightbox = useCallback((event, { photo, index }) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  }, []);

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  return (
    <div>
      <YakshaganaStringPuppetsSection
        title={"Performance Photos"}
        image1={null}
      />
      <Gallery photos={photos} onClick={openLightbox} />
      <ModalGateway>
        {viewerIsOpen ? (
          <Modal onClose={closeLightbox}>
            <Carousel
              currentIndex={currentImage}
              views={photos.map((x) => ({
                ...x,
                srcset: x.srcSet,
                caption: x.title,
              }))}
            />
          </Modal>
        ) : null}
      </ModalGateway>
    </div>
  );
}

export default PerformancePhotos;
